import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Notification {
  name: string;
  api_token: string;
}

export interface NotificationListInfor {
  errors: unknown;
  notification: Notification;
  isAuthenticated: boolean;
}

@Module
export default class NotificationModule
  extends VuexModule
  implements NotificationListInfor
{
  errors = {};
  notification = {} as Notification;
  isAuthenticated = !!JwtService.getToken();

  get Notifications() {
    return this.notificationListData;
  }

  @Mutation
  [Mutations.NOTIFICATIONS_LIST_DATA](Notifications) {
    this.notificationListData = Notifications;
  }

  @Action
  [Actions.NOTIFICATION_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("notifications/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.NOTIFICATIONS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NOTIFICATION_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("notifications", payload)
        .then((data) => {
          this.context.commit(Mutations.NOTIFICATIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NOTIFICATION_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/notifications",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.NOTIFICATIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.NOTIFICATION_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/notifications", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.NOTIFICATIONS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
